// The weekly hat (PLAN-2026-10-30-the-weekly-hat §2): the week's low score
// wears it and the week's high score picks it, by the awards engine's own
// pickers over the same facts the week's awards are minted from, so a
// practice league and a real one put the same hat on the same team, and a
// correction that moves the low score moves the hat.
//
// THE HAT IS ITS OWN SWITCH. A league that turned the High Score or the Toilet
// Bowl off still has a hat, so the pickers run under the default rules rather
// than the league's.

import { DEFAULT_CATALOG } from './catalog';
import { periodAwards } from './engine';
import { DEFAULT_RULES, type SeasonFacts } from './types';

export interface WeekHat {
  /** Every team tied for the fewest points: they wear it together. */
  wearers: string[];
  /** Every team tied for the most: any of them picks. */
  pickers: string[];
  /** The fewest points, and the most. */
  low: number;
  high: number;
}

/**
 * Who wears the week's hat and who picks it, or null for a week with none: one
 * not over, one the engine names nobody for (a field under three, a final
 * alone), or one where every team scored the same and the wearers would pick
 * their own.
 */
export function weekHat(facts: SeasonFacts, period: number): WeekHat | null {
  const p = facts.periods.find((x) => x.period === period);
  if (!p?.final) return null;
  const results = periodAwards(facts, period, DEFAULT_CATALOG, DEFAULT_RULES);
  const high = results.find((r) => r.awardId === 'high-score');
  const low = results.find((r) => r.awardId === 'low-score');
  if (!high || !low || high.winners.length === 0 || low.winners.length === 0) return null;
  const wearers = low.winners.map((w) => w.teamId).sort();
  const pickers = high.winners.map((w) => w.teamId).sort();
  if (wearers.some((t) => pickers.includes(t))) return null;
  return { wearers, pickers, low: low.winners[0]!.value, high: high.winners[0]!.value };
}
